import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// presentational component
import Activities from '../../../components/Pages/Program/Purchased/components/Activities';

// account reselectors
import { getUserWorkoutSessionsProgram } from '../../../reducers/workout';

// program actions
import { requestFetchWorkoutSessionsProgram } from '../../../actions/workout';

const mapStateToProps = (state, props) => {
  return {
    activities: getUserWorkoutSessionsProgram(props)(state),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      requestFetchWorkoutSessionsProgram,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Activities);
